import { render } from "./DashboardChartWrapper.vue?vue&type=template&id=54b6b3de"
import script from "./DashboardChartWrapper.vue?vue&type=script&lang=js"
export * from "./DashboardChartWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__